import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Site extends Model {
  resource() {
    return 'sites'
  }

  get bannerSource() {
    if (!this.banner) {
      return require('@/assets/images/default-profile.png')
    }

    return this.banner.url
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
